import React, { Component, ReactElement } from "react";
import App from "./App";

interface State {
  domain: string;
}

interface Props {
  component: React.ComponentClass<{
    domain: string;
  }>;
}

class ShopProvider extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const root: HTMLElement | null = document.querySelector("#przm-root");
    const shopifyDomain = root && root.dataset.shopifyDomain;
    if (!shopifyDomain) {
      throw new Error(
        "Expected the mount point `przm-root` to define `data-shopify-domain"
      );
    }
    this.state = { domain: shopifyDomain };
  }
  render() {
    const { domain } = this.state;
    const { component } = this.props;

    return (
      <>
        {React.createElement(component, {
          domain
        })}
      </>
    );
  }
}

export default ShopProvider;
